window.slugify = function (content) {
  return content.toLowerCase().replace(",", "").replace(/\s+/g, "-");
};
